<template>
	<div class="w-100 my-5 py-4">
		<loader />
	</div>
</template>
<script>
	import {mapMutations,mapGetters} from 'vuex'
	import moment from 'moment'
	export default{
		metaInfo(){
      return {title:'Loading...'}
    },
		mounted(){
			let params = {
				date: {
					check_in: moment().toDate(),
					check_out: moment().add(this.$defaultFilterBE('night'),'d').toDate(),
				},
				guest: {
					adult: this.$defaultFilterBE('adult'),
					child: 0,
					infant: 0,
				},
				promo_code: this.$route.params.promo_code
			}
			this.setBeFilter(params)
			this.resetBECart()
			this.setBeSortBy('room_type')
			this.setBeFilterDetail({
				type: 'room_type',
				data: {}
			})
			let self = this
			setTimeout(() =>{
				self.$router.push({
					name : 'BERoom'
				})
			},300)
		},
		methods:{
			...mapMutations(['setBeFilter','resetBECart','setBeSortBy','setBeFilterDetail']),
			...mapGetters(['getMerchant'])
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/be/BeDirectPromo.vue